import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from './node_modules/.pnpm/react-hook-form@7.41.1_react@18.2.0/node_modules/react-hook-form/dist/index.esm.js';

const Form = ({ children, className = '', clearResults = false, mode = 'all', onSubmit, shouldFocusError = true, defaultValues = {}, ...rest }) => {
    const methods = useForm({
        ...rest,
        defaultValues,
        criteriaMode: 'all',
        mode,
        shouldFocusError,
    });
    const [isClear, toggleClear] = useState(false);
    useEffect(() => {
        toggleClear(clearResults);
    }, []);
    // Reset form values when defaultValues change (for async form state assignment)
    // e.g. we call the `create` signup MC API and we get values that we want to assign to form fields
    useEffect(() => {
        if (defaultValues && !methods.formState.isDirty) {
            methods.reset(defaultValues, { keepErrors: true });
        }
    }, [defaultValues]);
    if (!isClear && clearResults) {
        methods.resetField('search');
        toggleClear(true);
    }
    return (React.createElement(FormProvider, { ...methods },
        React.createElement("form", { onSubmit: methods.handleSubmit(async (data) => await onSubmit(data, methods)), onChange: e => {
                if (e.target.value !== '') {
                    toggleClear(false);
                }
            }, className: `grid ${className}`, noValidate: true }, children)));
};

export { Form };
//# sourceMappingURL=Form.js.map
